const QUESTIONS = [
  { value: "1", label: "Q1", hint: "Easy",   color: "green"  },
  { value: "2", label: "Q2", hint: "Medium", color: "blue"   },
  { value: "3", label: "Q3", hint: "Hard",   color: "purple" },
  { value: "4", label: "Q4", hint: "Expert", color: "red"    },
];

const colorMap = {
  green:  { active: "bg-green-500/20  border-green-500/60  text-green-300",  dot: "bg-green-400",  hover: "hover:border-green-500/30 hover:text-green-300/70"  },
  blue:   { active: "bg-blue-500/20   border-blue-500/60   text-blue-300",   dot: "bg-blue-400",   hover: "hover:border-blue-500/30  hover:text-blue-300/70"   },
  purple: { active: "bg-purple-500/20 border-purple-500/60 text-purple-300", dot: "bg-purple-400", hover: "hover:border-purple-500/30 hover:text-purple-300/70" },
  red:    { active: "bg-red-500/20    border-red-500/60    text-red-300",    dot: "bg-red-400",    hover: "hover:border-red-500/30   hover:text-red-300/70"    },
};

function QuestionSelector({ value, onChange }) {
  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-500 uppercase tracking-widest font-medium">
        Question Position
      </p>

      <div className="grid grid-cols-4 gap-2">
        {QUESTIONS.map(({ value: qVal, label, hint, color }) => {
          const isActive = value === qVal;
          const c = colorMap[color];

          return (
            <button
              key={qVal}
              onClick={() => onChange(qVal)}
              className={`
                flex flex-col items-center gap-1 px-3 py-3
                rounded-xl border text-sm font-semibold
                transition-all duration-200 cursor-pointer
                ${isActive
                  ? `${c.active} shadow-lg scale-[1.03]`
                  : `border-white/10 text-gray-400 ${c.hover}`
                }
              `}
            >
              <span className="text-base">{label}</span>
              <span className="flex items-center gap-1 text-[10px] font-normal opacity-80">
                <span className={`inline-block w-1.5 h-1.5 rounded-full ${isActive ? c.dot : "bg-gray-600"}`} />
                {hint}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default QuestionSelector;
